import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '../src/tailwind.css'

import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Home';
import AboutUsHome from './pages/About/about';
import ContactPage from './pages/Contact/contact';
import Apply from './components/Apply';

import './index.css';
import CCTV from './pages/Services/CCTV';
import CCTVSol from './pages/Solutions/CCTVSol';
import SolutionCard from './pages/Solutions/SolutionCard'
import Solutions from './pages/Solutions/Solutions';
import Server from './pages/Solutions/Server';
import Virtualization from './pages/Solutions/Virtualization';
import IPTelephony from './pages/Solutions/IPTelephony'
import Storage from './pages/Solutions/Storage';

import ITSupport from './pages/Services/ITSupport'
import Network from './pages/Services/Network';
import Consult from './pages/Services/Consult';
import Critical from './pages/Services/Critical';
import Software from './pages/Services/Software';
import Onsite from './pages/Services/Onsite';
import ServiceHome from './pages/Services/our-services';

import Careers from './pages/Careers/Careers';
import Products from './pages/Products/Products';
import ProductsCard from './pages/Products/ProductsCard';
import BoardPage from './components/BoardPage';
import OurClients from './components/OurClients'


function App() {
  return (
    <Router>
      <div className="flex flex-col w-full"> 
     
        <Header /> {/* Include Header component */}
        <main className="flex-grow w-full">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/AboutUsHome" element={<AboutUsHome />} />
            <Route path="/ContactPage" element={<ContactPage />} />
            <Route path="/Apply" element={<Apply />} />

            <Route path='/ServiceHome' element={<ServiceHome/>}/>
            <Route path="/ITSupport" element={<ITSupport />} />
            <Route path='/Critical' element={<Critical/>}/>
            <Route path='/Network' element={<Network/>}/>
            <Route path='/Onsite' element={<Onsite/>}/>
            <Route path='/Software' element={<Software/>}/>
            <Route path='/Consult' element={<Consult/>}/>

            <Route path="/Solutions" element={<Solutions/>} />
            <Route path="/CCTV" element={<CCTV/>} />
            <Route path='/CCTVSol' element={<CCTVSol/>} />
            <Route path="/SolutionCard" element={<SolutionCard/>} />
            <Route path='/Storage' element={<Storage/>}/>
            <Route path='/Server' element={<Server/>} />
            <Route path='/Virtualization' element={<Virtualization />} />
            <Route path='/IPTelephony' element={<IPTelephony/>}/>

            <Route path='/Careers' element={<Careers/>} />

            <Route path='/Products' element={<Products/>} />
            <Route path='/ProductsCard' element={<ProductsCard/>}/>
            <Route path='/BoardPage' element={<BoardPage/>} />
            <Route path='/OurClients' element={<OurClients/>} />
            
          </Routes>
        </main>
       
          <Footer />
      </div>
    </Router>
  );
}

export default App;
